









































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from 'axios';
import { General } from '@/services/General';
import { saveAs } from 'file-saver';
import { GarageAttachment } from "@/entity/GarageAttachment";

@Component
export default class GarageAttachmentDetails extends Vue {
  @Prop({
          required: true
      })
  attachments: Array<GarageAttachment>;

  @Prop({
          required: false
      })    
  editable: boolean;
  fileName: string = "";
  chunkSize: number = process.env.VUE_APP_CHUNK_SIZE_BYTE;
  uploadPerc: number = 0;
  idSession: string = "";
  attachmentsUploaded : Array<GarageAttachment> = [];
  noteFileToUpload: string = "";
  singleFile: GarageAttachment = new GarageAttachment();

  mounted(){
    this.setAttachmentsUpload(this.attachments);
  }

  setAttachmentsUpload(attachments : Array<any>){
    let app = this;
    if(attachments.length>0)
       attachments.forEach(function(a){
        app.attachmentsUploaded.push(a);
      });
  }

  async downloadAttachmentDo(attachment: GarageAttachment){
    if(attachment.id != undefined && attachment.id)
      await this.downloadAttachmentById(attachment);
    else
      await this.downloadDocumentGenericByIdSession(attachment);
  }

  async downloadDocumentGenericByIdSession(attachment: GarageAttachment){
    try {
      let response = await axios({
          method: 'get',
          url: General.GetApiUrl("/api/document/DownloadDocumentGenericByIdSession?idSession=" + attachment.sessionId),
          withCredentials: true,
          responseType: 'blob'
      });
      saveAs(new Blob([response.data]), attachment.nome);
    } catch (error) {
        General.showAlertDanger("Download error, please retry. If the problem stll present contact your IT", this);                          
    }
  }

  async downloadAttachmentById(attachment: GarageAttachment){
    try {
        let response = await axios({
            method: 'get',
            url: General.GetApiUrl("/api/sign/DownloadGarageAttachment?attachmentId=" + attachment.id),
            withCredentials: true,
            responseType: 'blob'
        });
        saveAs(new Blob([response.data]), attachment.nome);
    } catch (error) {
        General.showAlertDanger("Download error, please retry. If the problem stll present contact IT", this);                               
    }
  }

  showSuccessAlert(sessionId: any) {
    this.idSession = sessionId;
    this.uploadPerc = 100;
  }

  confirmAttachment() {
    if(this.idSession !== undefined && this.idSession != null && this.idSession !== "") {
      let newAttachment = new GarageAttachment();
      newAttachment.nome = this.fileName;
      newAttachment.status = "uploaded";
      newAttachment.sessionId = this.idSession
      newAttachment.note = this.noteFileToUpload;

      this.singleFile = newAttachment;
      this.attachmentsUploaded.push(this.singleFile);
      this.$emit("attachmentsChange", this.singleFile);

      this.noteFileToUpload = null;  
      this.singleFile = new GarageAttachment();

      this.$bvModal.hide('add-file-modal'); 
    } else {
      General.showAlertDanger("Attenzione: selezionare il file da allegare", this);
    }
  }

  removeAttachment(attachment:GarageAttachment, index: number){
    General.confirm(
      "Do you want remove attachment:" + attachment.nome + "?",
      this,
      async () => {
        attachment.status="deleted";
        Vue.set(this.attachmentsUploaded, index, attachment) 
        this.$emit("removeAttachmentChange", attachment);
      }  
    );  
  }

  updateProgress(e: any) {
    this.uploadPerc = e;
  }

  getFileName(fileName: string) {
    this.fileName = fileName;
  }

  reset() {
    this.uploadPerc = 0;
    this.fileName = "";
    this.idSession = "";
  }
}
